import {BaseService} from './base.service';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AutenticacaoClienteSiteService extends BaseService {


    constructor(private httpClient: HttpClient) {
        super(httpClient, 'cliente-site');
    }

    public async authenticate(data: any): Promise<any> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .post<any>(`${this.path()}/authenticate`, data, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }

    }

    public async sendForgotPassword(data: any): Promise<any> {
        try {
            data.dominio = this.domain;
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .post<any>(`${this.path()}/esqueceu-senha`, data, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }

    }

    public async forgotPassword(data: any): Promise<any> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .post<any>(`${this.path()}/alterar-esqueceu-senha`, data, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res, 200))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }

    }
}
